import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {graphql, compose, withApollo} from 'react-apollo'
import {AvForm, AvField} from 'availity-reactstrap-validation'
import {Button, Col, Row, Progress, FormGroup, FormFeedback, Input} from 'reactstrap'
import _ from 'lodash'
import DropzoneComponent from 'react-dropzone-component'
import {UploadFiles, acceptedFiles, acceptedFilesIcons, updateAttachemntsInStore} from '../../utils/uploadFiles'
import {SAVE_PROJECT} from './mutations'
// import {withGaTracker, withGaEvent} from '../Support/GoogleAnalytics'
import CreatableSelect from '../Wps/CreatableSelect'
import {FilesList} from '../Support'
import {onDestroySelect, destroyAttachments} from '../../utils/forms/removeFiles'

import {getUserPermissions} from '../../utils/userPermissions'

class ProjectForm extends Component {

  constructor(props) {
    super(props)
    let extra_columns_data = props.editData.extra_columns ? JSON.parse(props.editData.extra_columns) : {}
    let extra_columns = []
    for (const [k, v] of Object.entries(extra_columns_data)) {
      extra_columns.push({name: v, uid: k})
    }

    this.state = {
      files: [],
      filesSelectedToRemove: [],
      validation_errors: {},
      submitFormProgress: null,
      extra_columns: extra_columns,
      project_companies: typeof props.editData.project_companies === 'string' ? JSON.parse(props.editData.project_companies) : (props.editData.project_companies || []),
      require_attachments: props.editData.require_attachments || false
    }

    this.djsConfig = {
      addRemoveLinks: true,
      autoProcessQueue: false,
      acceptedFiles: acceptedFiles,
    }
    this.componentConfig = {
      iconFiletypes: acceptedFilesIcons,
      showFiletypeIcon: true,
      postUrl: 'no-url',
    }
    this.dropzone = null

    this.onDestroySelect = onDestroySelect.bind(this)
    this.submitFunction = this.submitFunction.bind(this)
  }

  componentDidUpdate(prevProps) {
    if (prevProps.editData.project_companies !== this.props.editData.project_companies) {
      const raw = this.props.editData.project_companies
      this.setState({
        project_companies: typeof raw === 'string' ? JSON.parse(raw) : (raw || [])
      })
    }
  }

  static propTypes = {
    client: PropTypes.object.isRequired,
    createOrUpdateProjectsMutation: PropTypes.func.isRequired,
    editData: PropTypes.object,
    formToggleFunction: PropTypes.func,
    companiesData: PropTypes.array.isRequired,
  }

  componentDidMount() {
    // withGaTracker(window.location.pathname + '/project_form') // GA TRACKER
  }

  componentWillUnmount() {
    // this.props.clearFunction()
  }

  preparedExtraColumns() {
    let extra_columns = {}
    this.state.extra_columns.forEach(ec_obj => {
      extra_columns[ec_obj.uid.replace(/[^a-zA-Z_0-9]/g, '').toLowerCase().replace(' ', '_')] = ec_obj.name
    })
    return JSON.stringify(extra_columns)
  }

  submitFunction(e, values) {
    this.props.createOrUpdateProjectsMutation({
      variables: {
        attributes: {
          id: Number(this.props.editData.id) || null,
          ..._.pick(values, 'name', 'number', 'conditions_of_acceptance', 'customer', 'planned_start_date', 'planned_end_date'),
          extra_columns: this.preparedExtraColumns(),
          project_companies: JSON.stringify(this.state.project_companies),
          repair_welding_overlap: Number(values.repair_welding_overlap),
          repair_inspection_overlap: Number(values.repair_inspection_overlap),
          require_attachments: this.state.require_attachments
        }
      },
      refetchQueries: ({data: {createOrUpdateProjects}}) => {
        const queries = !this.props.editData.id && !createOrUpdateProjects.errors ? ['ProjectsListQuery'] : []
        return [...queries, 'GetElement']
      },
    }).then(({data: {createOrUpdateProjects}}) => {
      if (createOrUpdateProjects.errors) {
        // withGaEvent({category: 'Project', action: 'error save'}) // GA EVENT
        this.setState({validation_errors: JSON.parse(createOrUpdateProjects.errors)})
      } else {
        // withGaEvent({category: 'Project', action: 'save'}) // GA EVENT
        let project_id = createOrUpdateProjects.project.id
        // REMOVE FILES
        destroyAttachments(this.props.client, this.state.filesSelectedToRemove, project_id, 'WlWelds::Project', 'Project')

        // ADD FILE
        if (this.state.files.length > 0) {
          UploadFiles(project_id, 'WlWelds::Project', this.state.files, {onUploadProgress: this.uploadProgress.bind(this)}).then((data) => {
            updateAttachemntsInStore(this.props.client, project_id, 'Project', {newAttachments: data})
          })
        }

        this.setState({files: [], filesSelectedToRemove: [], validation_errors: {}})
        this.dropzone.removeAllFiles(true)
        this.props.onSaved && this.props.onSaved()
        this.props.formToggleFunction && this.props.formToggleFunction()
      }
    })
  }

  uploadProgress(progressEvent) {
    let percentage = Math.round(progressEvent.loaded * 100.0 / progressEvent.total)
    this.setState({submitFormProgress: percentage === 100 ? null : percentage})
  }

  handleFileAdded(file) {
    this.setState({files: [...this.state.files, file]})
  }

  handleFileRemoved(file) {
    let newFilesList = this.state.files.filter(function (item) {
      return (item !== file)
    })

    this.setState({files: newFilesList})
  }

  render() {
    const eventHandlers = {
      init: dz => this.dropzone = dz,
      addedfile: this.handleFileAdded.bind(this),
      removedfile: this.handleFileRemoved.bind(this),
    }

    return (
      <AvForm id="projects-form" onValidSubmit={this.submitFunction} className="FormClassLabel">
        {this.state.validation_errors &&
        <h4 className="errors-heading">
          {Object.keys(this.state.validation_errors).map(key => `${key}: ${this.state.validation_errors[key]}`).join(', ')}
        </h4>
        }
        <Row>
          <Col xs="12" md='3'>
            <AvField
              id="name-projects-form"
              name="name"
              label="Name"
              type="text"
              required
              validate={{pattern: {value: '^[A-Za-z0-9 _-]+$'}}}
              value={this.props.editData.name || ''}
            />
          </Col>
          <Col xs="12" md='3'>
            <AvField
              id="number-projects-form"
              name="number"
              label="Number"
              type="text"
              required
              validate={{pattern: {value: '^[A-Za-z0-9]+$'}}}
              value={this.props.editData.number || ''}
            />
          </Col>
          <Col xs="12" md='3'>
            <AvField
              id="conditions-projects-form"
              name="conditions_of_acceptance"
              label="Conditions of acceptance"
              type="text"
              required
              validate={{pattern: {value: '^[A-Za-z0-9 _-]+$'}}}
              value={this.props.editData.conditions_of_acceptance || ''}
            />
          </Col>
          <Col xs="12" md='3'>
            <AvField
              id="customer-projects-form"
              name="customer"
              label="Customer"
              type="text"
              validate={{pattern: {value: '^[A-Za-z0-9 _-]+$'}}}
              value={this.props.editData.customer || ''}
            />
          </Col>
        </Row>
        <Row>
          <Col xs="12" md='3'>
            <AvField
              id="planned_start_date-projects-form"
              name="planned_start_date"
              label="Planned start date"
              type="date"
              value={(this.props.editData.planned_start_date || '').split('-').reverse().join('-')}
            />
          </Col>
          <Col xs="12" md='3'>
            <AvField
              id="planned_end_date-projects-form"
              name="planned_end_date"
              label="Planned end date"
              type="date"
              value={(this.props.editData.planned_end_date || '').split('-').reverse().join('-')}
            />
          </Col>
          <Col xs="12" md='3'>
            <AvField
              id="repair-welding-overlap-projects-form"
              name="repair_welding_overlap"
              label="Repair welding extension size"
              step='1'
              type="number"
              value={this.props.editData.repair_welding_overlap || 0}
            />
          </Col>
          <Col xs="12" md='3'>
            <AvField
              id="repair-inspection-overlap-projects-form"
              name="repair_inspection_overlap"
              label="Repair inspection extension size"
              type="number"
              step='1'
              value={this.props.editData.repair_inspection_overlap || 0}
            />
          </Col>
        </Row>
        <Row>
          <Col xs="12" sm="6">
            <FormGroup check>
              <label>
                <input
                  type="checkbox"
                  checked={this.state.require_attachments}
                  onChange={e => this.setState({ require_attachments: e.target.checked })}
                />
                {' '}Require attachments for inspections
              </label>
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col xs="12" sm="6">
            <label>Companies</label>
            {(this.props.companiesData || []).map(company => {
              const entry = this.state.project_companies.find(pc => String(pc.id) === String(company.id))
              const checked = !!entry
              const isExecutor = entry ? !!entry.executor : false
              return (
                <div key={company.id} style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '4px' }}>
                  <Input
                    type="checkbox"
                    checked={checked}
                    style={{ position: 'static', margin: 0 }}
                    onChange={e => {
                      if (e.target.checked) {
                        this.setState(s => ({ project_companies: [...s.project_companies, { id: company.id, executor: false }] }))
                      } else {
                        this.setState(s => ({ project_companies: s.project_companies.filter(pc => String(pc.id) !== String(company.id)) }))
                      }
                    }}
                  />
                  <span style={{ minWidth: '140px' }}>{company.name}</span>
                  {checked && (
                    <label style={{ margin: 0, display: 'flex', alignItems: 'center', gap: '4px', color: '#555' }}>
                      <Input
                        type="checkbox"
                        checked={isExecutor}
                        style={{ position: 'static', margin: 0 }}
                        onChange={e => {
                          const checked = e.target.checked
                          this.setState(s => ({
                            project_companies: s.project_companies.map(pc =>
                              String(pc.id) === String(company.id) ? { ...pc, executor: checked } : pc
                            )
                          }))
                        }}
                      />
                      executor
                    </label>
                  )}
                </div>
              )
            })}
            <FormFeedback>{this.state.validation_errors.project_companies}</FormFeedback>
          </Col>
          <Col xs="12" md="6">
            <CreatableSelect
              label="Extra columns"
              id="extra-columns-project-form"
              valueKey="uid"
              placeholder="Type each extra column and separate it by pressing enter"
              value={this.state.extra_columns}
              multi={true}
              creatable={true}
              valueChangeFunction={val => {
                this.setState({extra_columns: val})
              }}
            />
            <FormFeedback>{this.state.validation_errors.extra_columns}</FormFeedback>
          </Col>
        </Row>
        <br/>
        <FormGroup>
          <DropzoneComponent config={this.componentConfig} eventHandlers={eventHandlers}
            djsConfig={this.djsConfig}/>
        </FormGroup>
        <FilesList files={this.props.editData.attachments} onDestroySelect={this.onDestroySelect}/>
        <hr/>
        {this.state.submitFormProgress &&
        <div>
          <div className="clearfix">
            <div className="float-left">
              <strong>Saving...</strong>
            </div>
          </div>
          <Progress className="progress-xs" value={this.state.submitFormProgress}/>
        </div>}
        {this.props.formToggleFunction && <Button id="projects-form-close-btn" color="danger" className="float-right"
          onClick={this.props.formToggleFunction}>
          <i className="fa fa-close"/> Close
        </Button>}
        <Button id="projects-form-save-btn" type="submit" color="primary" className="float-right">
          <i className="fa fa-plus"/> Save
        </Button>
        <br/>
      </AvForm>
    )
  }
}

const ProjectFormWithMutations = compose(
  graphql(SAVE_PROJECT, {name: 'createOrUpdateProjectsMutation'})
)(withApollo(ProjectForm))

export default ProjectFormWithMutations



// WEBPACK FOOTER //
// ./src/components/Projects/ProjectForm.js